// extracted by css-extract-rspack-plugin
export default {"SectionBody":"iaZaM"};